export default {
  data() {
    return {
      // refresh variables
      mediaQuery: false,
    }
  },
  created() {
    this.mediaQuery = window.matchMedia("(max-width: 768px)")
  },
}